import { useRef, useEffect } from 'react';

export default function useReveal(deps = []) {
    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('visible'); }),
            { threshold: 0.12 }
        );
        const nodes = ref.current?.querySelectorAll('.reveal:not(.visible)');
        nodes?.forEach((n) => observer.observe(n));
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return ref;
}
